module.exports = __webpack_public_path__ + "img/skyward-blade.991060c6.webp";